/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodDrinkAlcoGlassWineIcon20Light = forwardRef('FoodDrinkAlcoGlassWineIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 3.611C3 2.721 3.721 2 4.611 2h9.778C15.279 2 16 2.721 16 3.611V6.5a6.5 6.5 0 0 1-6 6.481V17h4a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1h4v-4.019A6.5 6.5 0 0 1 3 6.5V3.611ZM4.022 7a5.5 5.5 0 0 0 10.956 0H4.022ZM15 6H4V3.611C4 3.274 4.274 3 4.611 3h9.778c.337 0 .611.274.611.611V6Z" })));
});
